module.exports = __webpack_public_path__ + "img/laoNianCan.5d3b14b6.png";